<style>
.Page_Title {
    position: relative;
    text-align: center;
    font-family: Montserrat;
    font-style: normal;
    font-weight: lighter;
    font-size: 50px;
    color: rgba(0, 0, 0, 1);
    display: block;
}


.tv_spots {
  font-family: Montserrat;
  border-collapse: collapse;
  width: 300px;
 margin-left:auto; 
 margin-right:auto;
 margin-top: 4rem;
 
}

 td, .tv_spots th {
  border-bottom: 1px solid #ddd;
  padding: 8px;
}

 tr:nth-child(even){background-color: #f2f2f2;}

 tr:hover {background-color: #ddd;}

 th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: white;
  color: black;
}
</style>

<script>
  import ButtonPopupImg from "../components/shared/buttons/ButtonPopupImg.svelte"
  import {getToken} from "../js-core/conn/auth/auth-main"
  let totalSpots, openSpots, approved = {}, allAdIds = [], loading
  const getBidsProm = getBids()
  async function getBids() {
    const res = await BSFetch("tv-owner/get-potential-ads", {
      method: "GET",
      headers: {
        authorization: getToken(),
        "Content-Type": "application/json"
      },
      mode: "cors",
      cache: "no-cache"
    });
    if (res.status === 200) {
      const resBody = await res.json();
      allAdIds = resBody.response.ads.map(ad => ad.id)
      openSpots = resBody.response.openSpots
      totalSpots = resBody.response.totalSpots
      return resBody.response.ads
    } else {
      throw {message: "There was an error getting your getting your bids"}
    }
  }
  async function submitBid() {
    loading = true
    const toApprove = allAdIds.filter((id, index) => approved[index] === true) 
    console.log(toApprove)
    if (toApprove.length === 0) { loading = false; return }
    const res = await BSFetch("tv-owner/select-ads", {
      method: "POST",
      headers: {
        authorization: getToken(),
        "Content-Type": "application/json"
      },
      mode: "cors",
      cache: "no-cache",
      body: JSON.stringify({
        adIds: toApprove 
      })
    })
    location.reload(); 
  }
</script>

<div class="Page_Title">
  <span>View Bids</span>
</div>
{#await getBidsProm}
  <p>Loading your information...</p>
{:then ads}
  <div class="Page_Title">
      <span style="font-size: 25px; font-weight: bold;">Spots Open: {openSpots}/{totalSpots}</span>
  </div>
  <table class="tv_spots">
  {#if allAdIds.length > 0}
    <!-- Header begins -->
    <tr>
      <th>Business Name</th>
      <!-- <th>Company Logo</th> -->
      <th>View Ad</th>
      <th>Approve Ad</th>
    </tr>
    <!-- Header ends -->
    {#each ads as ad, index}
      <tr class="{approved[index] ? 'Grey_Out' : ''}">
        <td>{ad.businessName}</td>
        <td><ButtonPopupImg id={ad.id} buttonHtml="Show Ad"></ButtonPopupImg></td>
        <td><input type="checkbox" bind:checked={approved[index]}></td>
      </tr>
    {/each}
      <button on:click={() => submitBid()} class="main action {loading ? 'loading' : ''}">Approve Checked Ads</button>
    {:else}
      Looks like you have no bids, consider adjusting your costs or uploading more profile pictures.
    {/if}
  </table>
{:catch error}
  <p>Something went wrong: {error.message}</p>
{/await}